<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section">
				<header class="section-header">
					<h2 class="section-title">{{ $t('receipts.section_title') }}</h2>
				</header>
				<article>
					<actions-panel extra-class="space-between">
						<button class="button style-1" type="button" @click.stop="showFilter = !showFilter">
							<span class="inner"><i class="fa-thin fa-sliders"></i> {{ $t('receipts.filter_export') }}</span>
						</button>
						<button class="button style-4" type="button" @click.stop="$store.commit('TOGGLE_RECEIPTS_CREATE_FORM')">
							<span class="inner">{{ $t('receipts.add_receipt') }}</span>
						</button>
					</actions-panel>
					<receipts-filter-form v-show="showFilter" :filtered-ids="exportIds"/>
					<panel-boxes-container :data="receipts" v-if="receipts.length"/>
					<p class="no-data" v-else>{{ $t('receipts.no_receipts') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
	import ActionsPanel from "../components/panels/ActionsPanel";
	import PanelBoxesContainer from "../components/containers/PanelBoxesContainer";
	import ReceiptsFilterForm from "../components/forms/ReceiptsFilterForm";

	export default {
		name: "Receipts",
		components: {
			ActionsPanel,
			PanelBoxesContainer,
			ReceiptsFilterForm,
		},
		data() {
			return {
				showFilter: false,
				search: '',
				date_from: '',
				date_to: '',
			}
		},
		computed: {
			exportIds() {
				const hasFilter = !!(this.search || this.date_from || this.date_to);
				if (!hasFilter) return null;
				return this.receipts.map(r => r.id);
			},
			receipts() {
				const items = this.$store.state.views.receipts || [];
				const q = (this.search || '').trim().toLowerCase();
				const from = this.date_from ? this.$moment(this.date_from, 'D.M.YYYY').startOf('day') : null;
				const to   = this.date_to   ? this.$moment(this.date_to,   'D.M.YYYY').endOf('day')   : null;

				return items
					.filter(item => {
						if (q) {
							const hay = `${item.name || ''} ${item.merchant_name || ''}`.toLowerCase();
							if (!hay.includes(q)) return false;
						}
						if (from || to) {
							const d = this.$moment(item.date);
							if (from && d.isBefore(from)) return false;
							if (to   && d.isAfter(to))   return false;
						}
						return true;
					})
					.map(item => ({
						id: item.id,
						name: item.name,
						date: this.$moment(item.date).format('D.M.YYYY'),
						category: item.merchant_name || '',
						price: item.total_price,
						currency: item.currency || 'EUR',
						detail: true,
						remove: true,
						type: 'receipt',
					}));
			}
		},
		methods: {
			onFieldChanged(payload) {
				if (payload && payload.name in this.$data) {
					this[payload.name] = payload.value;
				}
			}
		},
		mounted() {
			this.$root.$on('field-changed', this.onFieldChanged);
		},
		destroyed() {
			this.$root.$off('field-changed', this.onFieldChanged);
		}
	}
</script>

<style scoped lang="scss">
</style>
